import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import FormCaption, { CaptionType } from '@/components/view/atoms/form/FormCaption'
import Logo from '@/components/view/utils/logo/Logo'

export const TopBarStatus = {
  CANCEL: 'cancel',
  NEW: 'new',
  CHANGE: 'change',
  MEMO_CHANGE: 'memo-change'
} as const

export type TopBarStatus = (typeof TopBarStatus)[keyof typeof TopBarStatus]

interface Props {
  status?: TopBarStatus
  captionText?: string
  onCancel?: MouseEventHandler<HTMLButtonElement>
  loading?: boolean
  buttonText?: string
  withSide?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const TopBar = ({
  status = TopBarStatus.CANCEL,
  captionText,
  onCancel,
  loading = false,
  buttonText,
  withSide = false,
  onClick
}: Props) => {
  return (
    <>
      <div
        className={clsx(
          'z-on-header shadow-200 fixed inset-x-0 top-0 flex w-full py-3',
          status == TopBarStatus.MEMO_CHANGE ? 'bg-surface-caution' : 'bg-surface'
        )}
      >
        <div className='flex w-60 items-center pr-4 pl-6'>
          <Logo />
        </div>
        <div className='relative flex flex-1 justify-center px-16'>
          <div className='absolute top-1/2 left-16 -translate-y-1/2 transform'>
            {captionText && (
              <FormCaption
                type={status == TopBarStatus.CHANGE ? CaptionType.CAUTION : CaptionType.SECONDARY}
              >
                {captionText}
              </FormCaption>
            )}
          </div>
          <div
            className={clsx(
              'flex w-full flex-1 items-center justify-end gap-x-2',
              withSide ? 'max-w-[1152px]' : 'max-w-[800px]'
            )}
          >
            <div className='flex shrink-0 gap-x-2'>
              <Button type={'button'} onClick={onCancel} color={'tertiary'} size={'large'}>
                取り消す
              </Button>
              <Button
                type={'submit'}
                size={'large'}
                color={ButtonColor.PRIMARY_BRAND}
                disabled={status == TopBarStatus.CANCEL}
                loading={loading}
                onClick={onClick}
              >
                {buttonText ? buttonText : status == TopBarStatus.CHANGE ? '保存する' : '登録する'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopBar
